import { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import { useGetLandingTracking } from "../hooks/Landing/useGetLandingTracking"
import { initializeTracking, trackPageView } from "./tracking"
import { isRestaurantPublicTrackingPath } from "./trackingRoutes"

const TrackingInitializer = () => {
  const { pathname, search } = useLocation()

  const { handleGetLandingTracking } = useGetLandingTracking()

  const [isInitialized, setIsInitialized] = useState(false)

  const isRestaurantPublicPath = isRestaurantPublicTrackingPath(pathname)

  useEffect(() => {
    if (isRestaurantPublicPath || isInitialized) {
      return
    }

    let active = true

    handleGetLandingTracking()
      .then((config) => {
        if (!active) {
          return
        }

        initializeTracking(config)
        setIsInitialized(true)
      })
      .catch(() => {})

    return () => {
      active = false
    }
  }, [handleGetLandingTracking, isInitialized, isRestaurantPublicPath])

  useEffect(() => {
    if (isRestaurantPublicPath || !isInitialized) {
      return
    }

    trackPageView(`${pathname}${search}`, document.title)
  }, [isInitialized, isRestaurantPublicPath, pathname, search])

  return null
}

export default TrackingInitializer
